import React, { useEffect, useMemo } from 'react';
import { retroPublishedModalEntryPoint } from '@atlassian/jira-confluence-sprint-retro-published-modal/entrypoint';
import { useRetros } from '@atlassian/jira-confluence-sprint-retros/src/controllers/index.tsx';
import { ModalEntryPointContainer } from '@atlassian/jira-entry-point-modal-container';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { useBacklogSelector } from '../../../state';
import { getIsCompanyManaged, getProjectKey, getRapidViewId } from '../../../state/selectors/app';

const entryPointParams = {};
export default function ConfluenceRetryPublishedModal() {
	const projectKey = useBacklogSelector(getProjectKey);
	const rapidViewId = useBacklogSelector(getRapidViewId);
	const isCompanyManaged = useBacklogSelector(getIsCompanyManaged);

	const [state, actions] = useRetros();

	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		retroPublishedModalEntryPoint,
		entryPointParams,
	);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		if (state.isRetroPublished) {
			entryPointActions.load();
			actions.setIsRetroPublished(false);
		}
	}, [state.isRetroPublished, entryPointActions, actions]);

	const props = useMemo(
		() => ({
			projectKey,
			rapidViewId,
			isCompanyManaged,
		}),
		[projectKey, rapidViewId, isCompanyManaged],
	);

	return (
		<>
			<ModalEntryPointContainer
				entryPointReferenceSubject={entryPointReferenceSubject}
				entryPointActions={entryPointActions}
				id="jira-confluence-sprint-retro-published-modal"
				packageName="jira-confluence-sprint-retro-published-modal"
				teamName="helios-headcoach"
				runtimeProps={props}
			/>
		</>
	);
}
